type Props = {
  title: string
  createdAt: string
}

export const MobileHeader = ({ title, createdAt }: Props) => {
  return (
    <div className="space-y-2 pb-6">
      <h2 className="typo-headline3 font-bold text-black">{title}</h2>
      <p className="typo-label2 font-normal text-gray-500">{createdAt}</p>
    </div>
  )
}
